export const allRoles:UserRole[] = [
  'SUPER_ADMIN',
  'ADMIN',
  'MANAGER',
  'FRANCHISER',
  'USER',
];
